export const tribeTermsAndConditions = `Payment Policy
To complete your pre-booking, a non-refundable deposit of TTD $1,000 (USD $160) is required at the time of booking.
This deposit will be applied toward your 2027 costume down payment.
You will be required to complete the full costume down payment for your selected package within five (5) days of the official registration date (July/August).
Payments made within this five-day period will guarantee your spot in TRIBE Carnival 2027 and your section of choice. 
Failure to complete the required costume down payment within the stated timeframe may result in forfeiture of your pre-booked position and section guarantee.

Payment Methods
Pre-booking payments can be made via:
Online: Credit Card (Visa & MasterCard only) 
Mas Camp: Cash, Credit Card or Local Debit Card 
Your pre-booking is only confirmed upon receipt of payment.

Billing Disclaimer
All credit card transactions are processed in USD. Currency conversion rates are determined by your bank at the time of the transaction.
Customers outside of the U.S. may see variations based on their bank’s exchange rate and additional fees may apply.

Refunds / Returns Policy
Pre-booking deposits are non-refundable and non-transferable.
In the event that Carnival 2027 is cancelled or postponed, your payment will be transferred to the next Trinidad Carnival occurrence.

Costume Selection
Pre-booked customers will be invited to select their costumes during the official registration phase.

Data Privacy
We collect and use your information solely to process your booking and communicate relevant Carnival updates.
Your information will not be sold or shared with third parties outside of our organization.
We implement appropriate security measures to protect your data. All sensitive information submitted online is encrypted via secure protocols (HTTPS).

Contact Information
Email: info@carnivaltribe.com
Phone: (868) 235-6800
Address: Experience the Magic Ltd.
20 Rosalino Street, Woodbrook, Trinidad

`;
export const fogTermsAndConditions = `Payment Policy
To complete your pre-booking, a non-refundable deposit of TTD $1,000 (USD $160) is required at the time of booking.
This deposit will be applied toward your 2027 costume down payment.
You will be required to complete the full costume down payment for your selected package within five (5) days of the official registration date (July/August).
Payments made within this five-day period will guarantee your spot in TRIBE Carnival 2027 and your section of choice. 
Failure to complete the required costume down payment within the stated timeframe may result in forfeiture of your pre-booked position and section guarantee.

Payment Methods
Pre-booking payments can be made via:
Online: Credit Card (Visa & MasterCard only) 
Mas Camp: Cash, Credit Card or Local Debit Card 
Your pre-booking is only confirmed upon receipt of payment.

Billing Disclaimer
All credit card transactions are processed in USD. Currency conversion rates are determined by your bank at the time of the transaction.
Customers outside of the U.S. may see variations based on their bank’s exchange rate and additional fees may apply.

Refunds / Returns Policy
Pre-booking deposits are non-refundable and non-transferable.
In the event that Carnival 2027 is cancelled or postponed, your payment will be transferred to the next Trinidad Carnival occurrence.

Costume Selection
Pre-booked customers will be invited to select their costumes during the official registration phase.

Data Privacy
We collect and use your information solely to process your booking and communicate relevant Carnival updates.
Your information will not be sold or shared with third parties outside of our organization.
We implement appropriate security measures to protect your data. All sensitive information submitted online is encrypted via secure protocols (HTTPS).

Contact Information
Email: info@carnivaltribe.com
Phone: (868) 235-6800
Address: Experience the Magic Ltd.
20 Rosalino Street, Woodbrook, Trinidad

`;
export const calTermsAndConditions = `Payment Policy  
To successfully complete your booking, you will be required to make a full payment of TTD800.00 (118 USD). Deadline for booking payment is March 1st, 2025.   
  
Payments for bookings, can be paid either 
Online - Credit Card (Visa & MasterCard ONLY).
At the Mas Camp – Linx 

PLEASE NOTE THAT YOUR PACKAGE BOOKING WILL ONLY BE COMPLETED WHEN THE PAYMENT IS RECEIVED. 
 
Disclaimer 
Please note that ALL credit card transactions are billed in USD$, the rate of conversion will be determined by your bank at the time of booking.
Important: For customers outside of the U.S., the amount reflected on your credit card statement is the billed amount converted at the banks' prevailing rate on that day. Also   note that some banks/providers may charge an additional convenience fee.  
 
Refunds/Returns Policy 
Please note that once a payment is made, it is non-refundable. 
All packages will be sold on a first come first serve basis and are non-refundable. Should Carnival 2025 be postponed a refund will apply.

Consumer Data Privacy Statement - Information Collection, Use, and Sharing  
Caribbean Airlines is the sole owner of the information collected on this site. We only have access to/collect information that you voluntarily give us via email or other direct contact from you. We will not sell this information to anyone. 
Your contact information will be used to communicate with you in regard to your booking and Carnival-related business. We may also contact you with special promotions and offers. We will not share your information with any third party outside of our organization. 

Security 
We take precautions to protect your information. When you submit sensitive information via the website, your information is protected both online and offline. 
Wherever we collect sensitive information (such as credit card data), that information is encrypted and transmitted to us in a secure way. You can verify this by looking for “https” at the beginning of the address of the web page. 
Customer Service Contact Information
Email: ourcaribbeanexperience@caribbean-airlines.com 

Miles will be awarded to the customer whose name and account number are entered for the transaction ( “Qualifying Customer”) Qualifying customers will receive miles for each package purchased on the transaction. Qualifying customers will be able to update their Iere Mas profile with their Caribbean miles number up until 28th March 2025. (click here to recover your membership number https://caribbeanairlines.frequentflyer.aero/pub/#/main/not-authenticated/forgotFFId or here to create an account https://caribbeanairlines.frequentflyer.aero/pub/#/main/not-authenticated/enrollment). Miles will be created on 31st March 2025. Miles are non transferable except through the paid transfer miles feature. If a package is resold the miles will be retaned in the original qualifying customers account unless transferred via the paid Transfer miles feature. Use of miles is subject to the terms and conditions of the program  https://www.caribbean-airlines.com/#/caribbean-miles/programme-details/termsandconditions
`;

export const blissTermsAndConditions = `Payment Policy 
To complete your pre-booking, a non-refundable deposit of TTD $1,250 (USD $200) is required at the time of booking.
This deposit will be applied toward your 2027 costume down payment.
You will be required to complete the full costume down payment for your selected package within five (5) days of the official registration date (July/August).
Payments made within this five-day period will guarantee your spot in BLISS Carnival 2027 and your section of choice. 
Failure to complete the required costume down payment within the stated timeframe may result in forfeiture of your pre-booked position and section guarantee.

Payment Methods
Pre-booking payments can be made via:
Online: Credit Card (Visa & MasterCard only) 
Mas Camp: Cash, Credit Card or Local Debit Card 
Your pre-booking is only confirmed upon receipt of payment.

Billing Disclaimer
All credit card transactions are processed in USD. Currency conversion rates are determined by your bank at the time of the transaction.
Customers outside of the U.S. may see variations based on their bank’s exchange rate and additional fees may apply.

Refunds / Returns Policy
Pre-booking deposits are non-refundable and non-transferable.
In the event that Carnival 2027 is cancelled or postponed, your payment will be transferred to the next Trinidad Carnival occurrence.

Costume Selection
Pre-booked customers will be invited to select their costumes during the official registration phase.

Data Privacy
We collect and use your information solely to process your booking and communicate relevant Carnival updates.
Your information will not be sold or shared with third parties outside of our organization.
We implement appropriate security measures to protect your data. All sensitive information submitted online is encrypted via secure protocols (HTTPS).

Contact Information
Email: info@blisscarnival.com
Phone: (868) 235-6800
Address: Experience the Magic Ltd.
20 Rosalino Street, Woodbrook, Trinidad

`;

export const secretsTermsAndConditions = `Payment Policy
 To successfully complete your pre-booking, you will be required to make a deposit of $1000 TTD ($160 USD). Deadline for pre booking payment is July 1st, 2024,  
 This deposit will be applied to your 2025 costume package down payment. You will be required to complete the full costume down payment on the selected costume package of your choice within five days after the registration start date in July/August. 
 If payment is received within the five days after the costume registration start date you are guaranteed a spot in TRIBE Carnival band and the costume of your choice in the 2025 Trinidad & Tobago Carnival.
  
 Payments for pre-bookings, can be paid: 
 
 Online - Credit Card (Visa & MasterCard ONLY).
 At the Mas Camp – Cash or Linx 
 
 PLEASE NOTE THAT YOUR PRE-BOOKING WILL ONLY BE COMPLETED AND VALID WHEN THE BOOKING DEPOSIT PAYMENT IS RECEIVED. 
 
 Disclaimer 
 
 Please note that ALL credit card transactions are billed in USD$, the rate of conversion will be determined by your bank at the time of booking.
 Important: For customers outside of the U.S., the amount reflected on your credit card statement is the billed amount converted at the banks' prevailing rate on that day. Also note that some banks/providers may charge an additional convenience fee.  
 Refunds/Returns Policy
 Please note that once a pre-booking deposit is made, it is non-transferable. 
 
 If Carnival 2025 is cancelled or postponed, your payment will be transferred to the next available Trinidad Carnival for booking. 
 
 Costume Selection
 Persons who have completed their pre-booking will be required to select their costume in the second phase when costume registration begins. 
 
 
 Consumer Data Privacy Statement
 Information Collection, Use, and Sharing  
 We are the sole owners of the information collected on this site. We only have access to/collect information that you voluntarily give us via email or other direct contact from you. We will not sell this information to anyone. 
 
 Your contact information will be used to communicate with you in regard to your booking and Carnival-related business. We may also contact you with special promotions and offers. We will not share your information with any third party outside of our organization. 
 
 Security 
 We take precautions to protect your information. When you submit sensitive information via the website, your information is protected both online and offline. 
 
 Wherever we collect sensitive information (such as credit card data), that information is encrypted and transmitted to us in a secure way. You can verify this by looking for “https” at the beginning of the address of the web page. 
 Customer Service Contact Information
 Email:  info@carnivaltribe.com 
 Phone: 235-6800
 
 Experience the Magic Ltd. | 20 Rosalino Street, Woodbrook, Trinidad
  `;

export const pureTermsAndConditions = `Payment Policy 

To successfully complete your pre-booking, you will be required to make a deposit of $1000 TTD ($160 USD).  

This deposit will be applied to your 2025 costume package down payment. You will be required to complete the full down payment on the selected costume package of your choice within five days after the registration start date in July/August.  

If payment is received within the five days after the registration start date you are guaranteed a spot in TRIBE Carnival band and the costume of your choice in the 2025 Trinidad & Tobago Carnival. 

  
Payments for pre-bookings, can be paid:  
 
Online - Credit Card (Visa & MasterCard ONLY). 

At the Mas Camp – Cash or Linx  
 
PLEASE NOTE THAT YOUR PRE-BOOKING WILL ONLY BE COMPLETED AND VALID WHEN THE DEPOSIT PAYMENT IS RECEIVED.   
 
Disclaimer  
 
Please note that ALL credit card transactions are billed in USD$, the rate of conversion will be determined by your bank at the time of booking. 

Important: For customers outside of the U.S., the amount reflected on your credit card statement is the billed amount converted at the banks' prevailing rate on that day. Also note that some banks/providers may charge an additional convenience fee.  Shape 

Refunds/Returns Policy 

Please note that once a pre-booking deposit is made, it is non-transferable.  
 
If Carnival 2025 is cancelled or postponed, your payment will be transferred to the next available Trinidad Carnival for booking.  
Shape 

Costume Selection 

Persons who have completed their pre-booking will be required to select their costume in the second phase when costume registration begins.  
 
The pre-booking fee can be applied to all designs within the TRIBE Carnival band EXCEPT franchised/privately owned sections.Shape 

Consumer Data Privacy Statement 

Information Collection, Use, and Sharing   
We are the sole owners of the information collected on this site. We only have access to/collect information that you voluntarily give us via email or other direct contact from you. We will not sell this information to anyone.  
 
Your contact information will be used to communicate with you in regard to your booking and Carnival-related business. We may also contact you with special promotions and offers. We will not share your information with any third party outside of our organization.  
 
Security  
We take precautions to protect your information. When you submit sensitive information via the website, your information is protected both online and offline.  
 
Wherever we collect sensitive information (such as credit card data), that information is encrypted and transmitted to us in a secure way. You can verify this by looking for “https” at the beginning of the address of the web page. Shape 

Customer Service Contact Information 

Email:  info@carnivaltribe.com  

Phone: 235-6800 

Shape 

Experience the Magic Ltd. | 20 Rosalino Street, Woodbrook, Trinidad `;

export const hartsTermsAndConditions = `Payment Policy

In order to successfully register and complete your costume booking, you are required in the first instance to issue to us a non-refundable deposit. All additional pieces/add-ons must be paid for in full at the time of registration. Please note that this deposit is required regardless of the price of the costume. You will be required to pay any balance on the selected costume by 31st December 2025. 
  
  Minimum Deposit: TT$2000 (male and female). All add-on items such as feathered pieces and backpacks may require an additional deposit. The total minimum deposit amount will be calculated on checkout.

Costume packages must be paid for in full prior to collection. Payments could be made via the following options:

At the Mas Camp (Cash, Credit Card & Debit Card) and online via Credit Card (Visa & MasterCard ONLY).
Cheques will not be accepted as a form of payment.

PLEASE NOTE:

YOUR REGISTRATION WILL ONLY BE COMPLETED AND VALID WHEN THE ENTIRE DEPOSIT IS MADE.

DEPOSITS MUST BE MADE WITHIN FIVE (5) WORKING DAYS

COSTUMES MUST BE PAID FOR IN FULL BY 31ST DECEMBER 2025


Disclaimers

Masqueraders who fail to issue the full deposit by the due date will forfeit any and all monies initially issued as part-payment of the deposit. No exceptions allowed!
Costumes remain the property of the band until paid for in FULL and collected.
If FULL payment is not paid by the stipulated deadline date, all monies will be forfeited.
Please note that ALL credit cards issued outside of Trinidad & Tobago are billed in US$. Important: For multi-currency credit cards, your credit card statement may reflect the billed amount converted at the banks' prevailing rate on that day. Also note that some banks/providers may charge an additional convenience fee.

Refunds/Returns Policy

Please note that carnival costumes are custom-made items therefore once a down-payment is made, it is non-refundable. Exchange or switching of sections, changing of sizes and transfers will be facilitated up until September 30th, 2025. Requests must be submitted in writing to harts@hartscarnival.com. No returns are accepted after your costume is collected.


Delivery Policy

All costumes must be collected at the distribution centre by the owner. You must present a valid form of identification at the time of collection. Alternatively, you may authorize another person to collect on your behalf. The costume owner must log into their account and insert the name of the person authorized to collect on the owner’s behalf. The costume owner should then share their unique QR code with the authorized collector. The authorized person must present a valid form of identification to be collected.

All costumes must be paid in full to be eligible for costume delivery.

The costume distribution schedule will be emailed to all masqueraders and posted to our social media platforms and website. Different sections will have different distribution dates. The final date of costume distribution is Carnival Thursday, after which all uncollected costumes are no longer available.

Consumer Data Privacy Statement

Information Collection, Use, and Sharing
We are the sole owners of the information collected on this site. We only have access to collect information that you voluntarily give us via email or other direct contact from you. We will not sell this information to anyone.

Your contact information will be used to communicate with you with regards to your costume and Carnival-related business. We may also contact you with special promotions and offers. We will not share your information with any third party outside of our organization.

Security
We take precautions to protect your information. When you submit sensitive information via the website, your information is protected both online and offline.

Wherever we collect sensitive information (such as credit card data), that information is encrypted and transmitted to us in a secure way. You can verify this by looking for “https” at the beginning of the address of the web page.

Customer Service Contact Information

Phone: (868) 235-6800
Email: harts@hartscarnival.com
The Ultimate Hart Ltd. | 18 Rosalino Street, Woodbrook, Trinidad
`;
export const theLostTribeTermsAndConditions = `
Payment Policy

In order to successfully register and complete your costume booking, you are required in the first instance to issue to us a non-refundable deposit. All additional pieces/add-ons must be paid for in full at the time of registration. Please note that this deposit is required regardless of the price of the costume. You will be required to pay any balance on the selected costume by 31st December 2025. 
  
  Minimum Deposit: TT $2000/US $320 for all male and female costumes. All add-on items such as feathered pieces and backpacks will require an additional deposit. The total minimum deposit amount will be calculated on checkout.

Costumes must be paid in full prior to collection. Payments could be made via the following options:

At the Mas Camp (Cash, Credit Card & Debit Card) and online via Credit Card (Visa & MasterCard ONLY).
Cheques will not be accepted as a form of payment.

PLEASE NOTE:

YOUR REGISTRATION WILL ONLY BE COMPLETED AND VALID WHEN THE ENTIRE DEPOSIT IS MADE. 

DEPOSITS MUST BE MADE WITHIN FIVE (5) WORKING DAYS

COSTUMES MUST BE PAID FOR IN FULL BY 31ST DECEMBER 2025


Disclaimers

Masqueraders who fail to issue the full deposit by the due date will forfeit any and all monies initially issued as part-payment of the deposit. No exceptions allowed!
Costumes remain the property of the band until paid in FULL and collected.
If FULL payment is not paid by the stipulated deadline date, all monies will be forfeited.
Please note that ALL credit cards issued outside of Trinidad & Tobago are billed in US$. Important: For multi-currency credit cards, your credit card statement may reflect the billed amount converted at the banks' prevailing rate on that day. Also note that some banks/providers may charge an additional convenience fee.



Refunds/Returns Policy

Please note that carnival costumes are custom-made items therefore once a down-payment is made, it is non-refundable. Exchange or switching of sections, changing of sizes and transfers will be facilitated up until August 15th, 2025. Requests must be submitted in writing to info@losttribecarnival.com. No returns are accepted after your costume is collected.


Delivery Policy

All costumes must be collected at the distribution centre by the owner. You must present a valid form of identification at the time of collection. Alternatively, you may authorize another person to collect on your behalf. The costume owner must log into their account and insert the name of the person authorized to collect on the owner’s behalf. The costume owner should then share their unique QR code with the authorized collector. The authorized person must present a valid form of identification on collected.

All costumes must be paid in full to be eligible for costume delivery.

The costume distribution schedule will be emailed to all masqueraders and posted to our social media platforms and website. Different sections will have different distribution dates. The final date of costume distribution is Carnival Thursday, after which all uncollected costumes are no longer available.

Consumer Data Privacy Statement

Information Collection, Use, and Sharing
We are the sole owners of the information collected on this site. We only have access to collect information that you voluntarily give us via email or other direct contact from you. We will not sell this information to anyone.

Your contact information will be used to communicate with you with regards to your costume and Carnival-related business. We may also contact you with special promotions and offers. We will not share your information with any third party outside of our organization.

Security
We take precautions to protect your information. When you submit sensitive information via the website, your information is protected both online and offline.

Wherever we collect sensitive information (such as credit card data), that information is encrypted and transmitted to us in a secure way. You can verify this by looking for “https” at the beginning of the address of the web page.

Customer Service Contact Information

Phone: (868) 235-6800
Email: info@losttribecarnival.com
Prelim Services Ltd. | 59 Alberto Street, Woodbrook, Trinidad
`;

export const rogueTermsAndConditions = `Payment Policy 

To successfully complete your pre-booking, you will be required to make a deposit of $1000 TTD ($160 USD).  

This deposit will be applied to your 2025 costume package down payment. You will be required to complete the full down payment on the selected costume package of your choice within five days after the registration start date in July/August.  

If payment is received within the five days after the registration start date you are guaranteed a spot in TRIBE Carnival band and the costume of your choice in the 2025 Trinidad & Tobago Carnival. 

  
Payments for pre-bookings, can be paid:  
 
Online - Credit Card (Visa & MasterCard ONLY). 

At the Mas Camp – Cash or Linx  
 
PLEASE NOTE THAT YOUR PRE-BOOKING WILL ONLY BE COMPLETED AND VALID WHEN THE DEPOSIT PAYMENT IS RECEIVED.   
 
Disclaimer  
 
Please note that ALL credit card transactions are billed in USD$, the rate of conversion will be determined by your bank at the time of booking. 

Important: For customers outside of the U.S., the amount reflected on your credit card statement is the billed amount converted at the banks' prevailing rate on that day. Also note that some banks/providers may charge an additional convenience fee.  Shape 

Refunds/Returns Policy 

Please note that once a pre-booking deposit is made, it is non-transferable.  
 
If Carnival 2025 is cancelled or postponed, your payment will be transferred to the next available Trinidad Carnival for booking.  
Shape 

Costume Selection 

Persons who have completed their pre-booking will be required to select their costume in the second phase when costume registration begins.  
 
The pre-booking fee can be applied to all designs within the TRIBE Carnival band EXCEPT franchised/privately owned sections.Shape 

Consumer Data Privacy Statement 

Information Collection, Use, and Sharing   
We are the sole owners of the information collected on this site. We only have access to/collect information that you voluntarily give us via email or other direct contact from you. We will not sell this information to anyone.  
 
Your contact information will be used to communicate with you in regard to your booking and Carnival-related business. We may also contact you with special promotions and offers. We will not share your information with any third party outside of our organization.  
 
Security  
We take precautions to protect your information. When you submit sensitive information via the website, your information is protected both online and offline.  
 
Wherever we collect sensitive information (such as credit card data), that information is encrypted and transmitted to us in a secure way. You can verify this by looking for “https” at the beginning of the address of the web page. Shape 

Customer Service Contact Information 

Email:  info@carnivaltribe.com  

Phone: 235-6800 

Shape 

Experience the Magic Ltd. | 20 Rosalino Street, Woodbrook, Trinidad `;
